var wrap=function wrap(min,max,v){var rangeSize=max-min;return((v-min)%rangeSize+rangeSize)%rangeSize+min;};export{wrap};